// extracted by mini-css-extract-plugin
export default {"vehicle":"VehicleImage__vehicle-ueUf"};